export default __webpack_public_path__ + "assets/images/939f980552dfbf1c5fd7d8214cc83bb8.svg";